/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlocked_Success_ToastInputs */

const en_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record unlocked successfully`)
};

const fr_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement deverrouille avec succes`)
};

const de_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensatz erfolgreich entsperrt`)
};

const it_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record sbloccato con successo`)
};

const ru_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись успешно разблокирована.`)
};

const es_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro desbloqueado exitosamente`)
};

const zh_cn2_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`记录已成功解锁`)
};

const ja_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードのロック解除に成功しました`)
};

const hi_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड सफलतापूर्वक अनलॉक हो गया`)
};

const pt_pt2_explorer_info_unlocked_success_toast = /** @type {(inputs: Explorer_Info_Unlocked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro desbloqueado com sucesso`)
};

/**
* | output |
* | --- |
* | "Record unlocked successfully" |
*
* @param {Explorer_Info_Unlocked_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlocked_success_toast = /** @type {((inputs?: Explorer_Info_Unlocked_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlocked_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_unlocked_success_toast(inputs)
	if (locale === "de") return de_explorer_info_unlocked_success_toast(inputs)
	if (locale === "it") return it_explorer_info_unlocked_success_toast(inputs)
	if (locale === "ru") return ru_explorer_info_unlocked_success_toast(inputs)
	if (locale === "es") return es_explorer_info_unlocked_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_unlocked_success_toast(inputs)
	if (locale === "ja") return ja_explorer_info_unlocked_success_toast(inputs)
	if (locale === "hi") return hi_explorer_info_unlocked_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_unlocked_success_toast(inputs)
	return en_explorer_info_unlocked_success_toast(inputs)
});